var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83838 4.84375H8.20707V3.70089C8.20707 2.12375 6.79293 0.84375 5.05051 0.84375C3.30808 0.84375 1.89394 2.12375 1.89394 3.70089V4.84375H1.26263C0.568182 4.84375 0 5.35804 0 5.98661V11.7009C0 12.3295 0.568182 12.8438 1.26263 12.8438H8.83838C9.53283 12.8438 10.101 12.3295 10.101 11.7009V5.98661C10.101 5.35804 9.53283 4.84375 8.83838 4.84375ZM5.05051 9.98661C4.35606 9.98661 3.78788 9.47232 3.78788 8.84375C3.78788 8.21518 4.35606 7.70089 5.05051 7.70089C5.74495 7.70089 6.31313 8.21518 6.31313 8.84375C6.31313 9.47232 5.74495 9.98661 5.05051 9.98661ZM3.15657 4.84375V3.70089C3.15657 2.75232 4.00253 1.98661 5.05051 1.98661C6.09849 1.98661 6.94444 2.75232 6.94444 3.70089V4.84375H3.15657Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockFilled);
export default __webpack_public_path__ + "static/media/lock-filled.e2ceb1f326d7b2effe1c9b11e2040782.svg";
export { ForwardRef as ReactComponent };